import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlatformService {
  isChrome = () => /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  isFirefox = () => /Firefox/.test(navigator.userAgent);
  isOpera = () => /OPR/.test(navigator.userAgent);
  constructor() {}
}
